const paddedZeroes = (length: number) => {
  let pad = "";
  for (var i = 0; i < length; i++) {
    pad += "0";
  }
  return pad;
};

const AccessionNumber = ({ accession }: { accession?: string | null }) => {
  if (!accession) return null;

  const parts = accession.split("-");
  const [rest, last] = [parts.slice(0, -1), parts.at(-1)];
  const prefix = rest.join("-");
  const number = Number(last);
  const padBy = Math.max(0, (last?.length ?? 5) - `${number}`.length);

  return (
    <span className="AccessionNumber">
      {prefix}-{paddedZeroes(padBy)}
      {number && <strong>{number}</strong>}
    </span>
  );
};

export default AccessionNumber;
